import { render, staticRenderFns } from "./publictemplate.vue?vue&type=template&id=7383faee"
import script from "./publictemplate.vue?vue&type=script&lang=js"
export * from "./publictemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports